import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from "@angular/core";
import {
  FormControl,
  NgForm,
  Validators,
} from "@angular/forms";
import { Router} from "@angular/router";

import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFireDatabase } from "@angular/fire/database";

import { CarouselConfig } from "ngx-bootstrap/carousel";
import { UsersService } from "../../Services/users.service";

@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.scss"],
  providers: [
    {
      provide: CarouselConfig,
      useValue: { interval: 3000, noPause: false, showIndicators: false },
    },
  ],
})
export class SignupComponent implements OnInit, AfterViewInit {
  @ViewChild("name") nameField: ElementRef;
  @ViewChild("userForm") userForm: NgForm;
  userNameFormControl = new FormControl("", [Validators.required]);
  emailFormControl = new FormControl("", [Validators.required]);
  passwordFormControl = new FormControl("", [Validators.required]);
  isRegistering = false;
  // 'info', 'success', 'warning', 'danger'
  alertType = "";
  alertMsg = "";
  showAlert = false;
  constructor(
    public afAuth: AngularFireAuth,
    public db: AngularFireDatabase,
    private router: Router,
    private usersService: UsersService
  ) {}

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    this.nameField.nativeElement.focus();
  }

  register() {
    this.isRegistering = true;
    if (
      !this.userNameFormControl.valid ||
      !this.emailFormControl.valid 
    ) {
      this.isRegistering = false;
      return;
    }

    let userDataObject = {};
    let userId = "";

    let email = this.emailFormControl.value;
    let password = this.passwordFormControl.value;
    let userName = this.userNameFormControl.value;
    this.userForm.resetForm();

    userDataObject["email"] = email;
    userDataObject["name"] = userName;
    userDataObject["role"] = "user";
    this.afAuth
      .createUserWithEmailAndPassword(email, password)
      .then((value) => {
        userId = value.user.uid;
        var user = this.afAuth.currentUser.then((user)=>{
          this.updateUserDisplayName(user, userName, userDataObject);
          this.updateUserObject(user, userDataObject);
          this.router.navigate(["/signup-successful"]);
        }).catch((err)=> {
          this.isRegistering = false;
          this.showAlertToUser(
            "danger",
            "Couldn't update your user profile. Please contact support."
          );
          });
        
      })
      .catch((err) => {
        this.isRegistering = false;
        this.showAlertToUser(
          "danger",
          "Sorry! Could not successfully register you. Please try after sometime or contact support."
        );
      });
  }

  updateUserDisplayName(user, displayName, userDataObject) {

    user
      .updateProfile({
        displayName: displayName,
        photoURL: "",
      })
      .then(
        (response) => {this.sendVerificationEmail(user);},
        (error) => {}
      );
  }

  updateUserObject(user, userDataObject) {
    var userRef = this.db.database.ref("/Users/" + user.uid);
    userRef.set(userDataObject).catch(function (err) {});
  }

  sendVerificationEmail(user) {
    this.usersService
      .sendVerificationEmail(user.email, user.displayName, user.uid)
      .subscribe(
        (response) => {},
        (error) => {console.log(error)}
      );
  }

  redirectToTheMessagePage(status) {}

  showAlertToUser(type, message) {
    this.showAlert = true;
    this.alertType = type;
    this.alertMsg = message;
  }

  onAlertClosed(alert) {
    this.showAlert = false;
  }
}
